
import { base64UrlToString } from "@/lib/encoding";
import { ReceiptRequest, WalletMockService } from "@/services/backend";
import { LIDService } from "@/services/loginid";
import { useEffect, useState } from "react";
import { useSearchParams, useParams } from "react-router-dom";
import { CheckoutViewEnum, CheckoutRequest } from "../checkout";
import { Message, MessagingService } from "@/services/messaging";
import ParseUtil from "@/lib/parse";
import { Image, Text, Container, Grid, ActionIcon, Divider, Group, Chip, Badge, Stack, Button, Loader } from "@mantine/core";
import { IconUserCircle, IconCreditCard, IconFaceId, IconFingerprint, IconChevronDown, IconChevronRight } from "@tabler/icons-react";
import { error } from "console";
import { TxPayload } from "../checkout/CheckoutConfirmPrompt";


const mService = new MessagingService(window.parent);
export function PaymentHandlerPage() {


  const [txRef, setTxRef] = useState("");
  const [username, setUsername] = useState<string>("");
  const [token, setToken] = useState<string>("");
  const [view, setView] = useState<CheckoutViewEnum>(CheckoutViewEnum.Init);
  const [searchParams] = useSearchParams();
  const [webview, setWebview] = useState<boolean>(false);
  const [passkey, setPasskey] = useState<boolean>(false);
  const [order, setOrder] = useState<string>("");
  const [redirect, setRedirect] = useState<boolean>(false);
  const [payload, setPayload] = useState<CheckoutRequest | null>(null);
  const [cid, setCID] = useState<string>("");
  const [error, setError] = useState("");
  const [isLoading, setloading] = useState(false);

  const brand = process.env.REACT_APP_BRAND || "Paze";
  let params = useParams();
  useEffect(() => {

    const windowOpener = window.opener
    if (windowOpener) {
      console.log("window operner ", windowOpener)
    }
    const inIframe = window.self !== window.top;

    if (inIframe) {
      mService.onMessage((msg, origin) => onMessageHandle(msg, origin));
    } else {
      setRedirect(true);
      console.log("resize redirect");
      //window.self.resizeTo(400, 800);
    }

    const query_webview = searchParams.get("webview");
    if (query_webview) {
      setWebview(true);
      if (query_webview !== "null") {
        setView(CheckoutViewEnum.Confirmation);
        setUsername(query_webview);
      }
    }

    loadOrder();
  }, [searchParams]);

  function onMessageHandle(msg: Message, origin: string) { }
  async function loadOrder() {
    let cId = params.id;
    const queryData = searchParams.get("data");
    const tokenData = searchParams.get("token");
    let apayload = null;
    console.log("load order");
    if (queryData) {
      apayload = JSON.parse(base64UrlToString(queryData));
    }
    if (cId) {

      apayload = await WalletMockService.initCheckout(cId);
      setCID(cId);
    }
    if (tokenData) {
      console.log("load order");
      apayload = await WalletMockService.initCheckout(tokenData);
      cId = tokenData;
      setCID(tokenData);
    }

    if (cId) {
      const start = new Date();
      const checkoutId = "";
      //await sleep(5000);
      const txPayload = cId;
      const result = await LIDService.client.beginFlow({
        checkoutId: checkoutId,
        txPayload,
      });

      console.log("duration: ", (new Date().getTime() - start.getTime()) / 1000)
      if (result.nextAction === "passkey:tx") {
        apayload = await WalletMockService.initCheckout(cId);
        const orderId = await WalletMockService.setupOrder(apayload);

        setOrder(orderId);
        setPayload(apayload);
        setloading(true);
        setView(CheckoutViewEnum.Confirmation);
      } else {
        // fallback
        setView(CheckoutViewEnum.Login);
      }
    }
  }


  function ButtonIcon() {
    const SIZE = 24;
    if (token !== "") {
      return <IconCreditCard size={SIZE}></IconCreditCard>;
    } else {
      if (ParseUtil.isIPhone()) {
        return <IconFaceId size={SIZE}></IconFaceId>;
      } else {
        return <IconFingerprint size={SIZE}></IconFingerprint>;
      }
    }
  }

  async function onAgentConfirmHandle() {

    console.log("confirm agent checkout")

    if (payload?.preid) {
      console.log("confirm agent checkout", payload.preid)
      const atoken = await WalletMockService.notify(payload);
      const receipt: ReceiptRequest = {
        id: atoken,
        orderId: atoken,
        cid: cid,
        at: new Date().toLocaleDateString(),
      }
      await WalletMockService.storeReceipt(receipt);
      setToken(atoken);
      mService.sendMessageData({ id: order, token: atoken, passkey: true });
      setView(CheckoutViewEnum.AgentResult);
      return;
    }
  }

  async function confirmPayTranstion() {

    onAgentConfirmHandle()
    return;
    /*
        // clear prior result
        if (props.token !== "") {
          return props.onComplete(
            props.username,
            props.token,
            props.hasPasskey ? "passkey" : "none",
          );
        }
    
        clear();
    
        try {
          const result = await LIDService.client.performAction("passkey:tx", {
            txPayload: JSON.stringify(payData),
          });
    
          if (result.payloadSignature) {
            return props.onComplete(
              props.username,
              result.payloadSignature,
              "passkey",
            );
          }
        } catch (e: any) {
          setError(e.message || e.msg || e);
        }
          */
  }

  async function cancelTransaction() {
    mService.sendMessageData({ id: order, passkey: false, error: "user cancel" });
  }

  function clear() {
    setError("");
    setTxRef("");
  }

  return (
    <Container w="100%">
      {txRef && (
        <>
          <Grid>
            <Grid.Col span={12} ta="center">
              <Text c="green.5">Transaction Successfull</Text>
            </Grid.Col>
          </Grid>
        </>
      )}
      {error && <Text c="red.5">{error}</Text>}
      {!payload &&
        <ShowProgress message="Preparing payment at merchant" />

      }
      {payload &&
        <>
          <Grid gutter={0}>
            <Grid.Col span={6}>
              <Text fw={700} ta="left" c="primary" size="md">
                Cookies.com
              </Text>
            </Grid.Col>
            <Grid.Col span={6} ta="right" >
              <ActionIcon size={32} variant="subtle" aria-label="expand" >
                <IconUserCircle size={24} color="#818BB1" />
              </ActionIcon>
            </Grid.Col>
            <Divider mb="xs" mt="xs"></Divider>
            <Grid.Col span={12}>
              <Group>
                <Text fw={700} ta="left" size="sm" >
                  My Profile
                </Text>
                <Chip size="xs" disabled >John Smith </Chip>
              </Group>
            </Grid.Col>

            <Grid.Col
              span={2}
              style={{ display: "flex", justifyContent: "flex-start" }}
            >
              <Image h={28} w={56} src="/assets/my-bank.png" />
            </Grid.Col>
            <Grid.Col span={10}>
              <Text size="xs" ta="left">
                <b>My Bank Rewards</b>
                <br />
                ******6593
              </Text>
            </Grid.Col>
          </Grid>
          <Divider mb="xs" mt="xs"></Divider>
          <Grid gutter={0}>
            <Grid.Col span={6}>
              <Text fw={700} ta="left" size="sm">
                Items
              </Text>
            </Grid.Col>
            <Grid.Col span={6} ta="right" >
              <ActionIcon size={24} variant="subtle" aria-label="expand" >
                <IconChevronDown size={24} color="#818BB1" />
              </ActionIcon>
            </Grid.Col>
            {payload?.items?.map(item => {
              return (
                < >
                  <Grid.Col span={8} key={item.id + "a"}>
                    <Group>

                      <Text fw={500} ta="left" size="xs" lineClamp={1}>
                        <Badge size="xs" mr={4} autoContrast >
                          {item.quantity}x
                        </Badge>
                        {item.name}
                      </Text>
                    </Group>
                  </Grid.Col>
                  <Grid.Col span={4} key={item.id + "c"}>
                    <Text size="xs" ta="right">
                      {item.amount}
                    </Text>
                  </Grid.Col>
                </>
              )
            })
            }
          </Grid>
          <Divider mb="xs" mt="xs"></Divider>
          <Grid gutter={0}>
            <Grid.Col span={8}>
              <Text fw={500} ta="left" size="xs">
                SUBTOTAL
              </Text>
            </Grid.Col>
            <Grid.Col span={4}>
              <Text size="xs" ta="right">
                {payload?.subtotal}{" "}
              </Text>
            </Grid.Col>
            <Grid.Col span={8}>
              <Text fw={500} ta="left" size="xs">
                SHIPPING
              </Text>
            </Grid.Col>
            <Grid.Col span={4}>
              <Text size="xs" ta="right">
                {payload?.shipping}{" "}
              </Text>
            </Grid.Col>
          </Grid>
          <Grid mt={0}>
            <Grid.Col span={8}>
              <Text fw={500} ta="left" size="xs">
                TAX
              </Text>
            </Grid.Col>
            <Grid.Col span={4}>
              <Text size="xs" ta="right">
                {payload?.tax}{" "}
              </Text>
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={8}>
              <Text fw={700} ta="left">
                PAY {payload?.merchant}{" "}
              </Text>
            </Grid.Col>
            <Grid.Col span={4} ta="right">
              ${payload?.total}
            </Grid.Col>
          </Grid>
          <Divider mb="xs" mt="xs"></Divider>
          <Stack>

            <Button style={{ borderRadius: 16 }} mt="md" justify="space-between" leftSection={<span />} rightSection={ButtonIcon()} onClick={confirmPayTranstion}>
              Confirm details
            </Button>
            <Button variant="transparent" onClick={cancelTransaction}>Cancel transaction</Button>
          </Stack>
        </>
      }
    </Container>
  );

}

function ShowProgress(props: { message: string }) {
  return (
    <>
      <Stack justify="center" align="center" h="100%">
        <Text>{props.message}</Text>
        <Loader size={50} type="bars" />
      </Stack>
    </>
  );
}